// removed by extract-text-webpack-plugin
module.exports = {"body":"Body-style__body__e91c8cba"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/views/modal/Body-style.scss
// module id = 565
// module chunks = 7 8 10 11 13 37